(function () {
    const countdownElement = document.querySelector('.countdown-timer');
    if (!countdownElement) return;

    let countdownInterval;
    const startTitle = document.querySelector(".start_title");
    const endTitle = document.querySelector(".end_title");
    const startDateString = countdownElement.getAttribute("data-start-date");
    const startTimeString = countdownElement.getAttribute("data-start-time");
    const endDateString = countdownElement.getAttribute("data-end-date");
    const endTimeString = countdownElement.getAttribute("data-end-time");
    
    let targetEndDate = new Date(`${endDateString}T${endTimeString}`).getTime();
    const targetStartDate = new Date(`${startDateString}T${startTimeString}`).getTime();

    function updateDigit(unit, newValue) {
        const card = countdownElement.querySelector(`[data-unit="${unit}"]`);
        if (!card) return;

        const inner = card.querySelector('.scroll-card-inner');
        const digit = parseInt(newValue, 10);

        // Get card height (50px for desktop, 45px for mobile)
        const cardHeight = card.offsetHeight;

        // Calculate scroll position
        const scrollY = digit * cardHeight;
        inner.style.transform = `translateY(${scrollY}px)`;
    }

    function autoReset() {
		if (countdownElement.hasAttribute('data-auto-reset')) {
			const nextDate = new Date();
			nextDate.setDate(nextDate.getDate() + 1);
			nextDate.setHours(0, 0, 0, 0); // 12 AM

			const yyyy = nextDate.getFullYear();
			const mm = String(nextDate.getMonth() + 1).padStart(2, '0');
			const dd = String(nextDate.getDate()).padStart(2, '0');

            const newEndDateString = `${yyyy}-${mm}-${dd}`;
			const newEndTimeString = '00:00:00';
			const formatedValue = `${newEndDateString}T${newEndTimeString}`;

			targetEndDate = new Date(formatedValue);
            return false;
		} else {
            const zeroUnits = ['days-tens','days-ones','hours-tens','hours-ones','minutes-tens','minutes-ones','seconds-tens','seconds-ones'];
            zeroUnits.forEach(unit => updateDigit(unit, '0'));
            clearInterval(countdownInterval);
			return true;
		}
	}

    function updateCountdown() {
        const now = new Date().getTime();
        let distance = targetEndDate - now;

        if (targetStartDate > now) {
        if (startTitle) startTitle.classList.remove('hidden')
        if (endTitle) endTitle.classList.add('hidden')

        distance = targetStartDate - now;
        } else {
            if (startTitle) startTitle.classList.add('hidden')
            if (endTitle) endTitle.classList.remove('hidden')
        }

        if (distance <= 0 || isNaN(targetEndDate) || isNaN(distance)) {
            const timerEnded = autoReset();
        
            if (timerEnded) return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const daysStr = String(days).padStart(2, '0');
        const hoursStr = String(hours).padStart(2, '0');
        const minutesStr = String(minutes).padStart(2, '0');
        const secondsStr = String(seconds).padStart(2, '0');

        updateDigit('days-tens', daysStr[0]);
        updateDigit('days-ones', daysStr[1]);
        updateDigit('hours-tens', hoursStr[0]);
        updateDigit('hours-ones', hoursStr[1]);
        updateDigit('minutes-tens', minutesStr[0]);
        updateDigit('minutes-ones', minutesStr[1]);
        updateDigit('seconds-tens', secondsStr[0]);
        updateDigit('seconds-ones', secondsStr[1]);
    }

    setTimeout(() => {
        updateCountdown();
        countdownInterval = setInterval(updateCountdown, 1000);
    }, 2400);
})();